import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { Separator } from "@/components/ui/separator";

export function PostSkeleton() {
  return (
    <Card className="border-border">
      <CardHeader className="pb-3">
        <div className="flex items-start justify-between">
          <div className="flex flex-1 gap-3">
            {/* Avatar Skeleton */}
            <Skeleton className="h-12 w-12 rounded-full" />
            <div className="flex-1 space-y-2">
              {/* Name Skeleton */}
              <Skeleton className="h-4 w-32" />
              {/* Title and timestamp skeleton */}
              <Skeleton className="h-3 w-48" />
            </div>
          </div>
          {/* Menu button skeleton */}
          <Skeleton className="h-8 w-8 rounded-md" />
        </div>
      </CardHeader>

      <CardContent className="space-y-5 pt-0">
        {/* Post Content Skeleton */}
        <div className="space-y-2">
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-3/4" />
        </div>

        {/* Media Skeleton (optional - shown 50% of the time for variety) */}
        {Math.random() > 0.5 && <Skeleton className="h-64 w-full rounded-lg" />}

        <Separator />

        {/* Action Buttons Skeleton */}
        <div className="flex items-center gap-2">
          <Skeleton className="h-9 flex-1 rounded-md" />
          <Skeleton className="h-9 flex-1 rounded-md" />
          <Skeleton className="h-9 flex-1 rounded-md" />
        </div>
      </CardContent>
    </Card>
  );
}
